module.exports = __webpack_public_path__ + "static/img/chenlei.689172bd.jpg";